import axios from 'axios';

var xURL = "https://rewardsadmin.vivotek.com/";

if(window.location.href.indexOf(":3000")>0)
  xURL = "https://vivotekrewardsadmin.salazar.ew1.dev/";
if(window.location.href.indexOf(":8080")>0)
  xURL = "https://vivotekrewardsadmin.antonio.ew1.dev/";
if(window.location.href.indexOf("ew1")>0)
  xURL = "https://vivotekrewardsadmin.salazar.ew1.dev/";

const baseURL = xURL;
const DEBUG = false;

if(localStorage.token)
  axios.defaults.headers.common['Authorization']=localStorage.token;

export default  {
  setToken (token) {
    localStorage.token = token;
    axios.defaults.headers.common['Authorization']=token;
  },
  checkLogin () {
    axios.post(baseURL+'app_handler.php',{
      "object":"App",
      "function":"checkLogin"
    });
  },
  post (obj,func,params,callback) {
    axios.post(baseURL+'app_handler.php?obj='+obj+'&func='+func,{
      "object":obj,
      "function":func,
      "params":params
    }).then((response) => {
      callback(response.data)
      if(DEBUG)
        console.log(response.data);
    }).catch((error)   => { console.log(error) });
  },
  postform (obj,func,form,callback) {
    form.append('object', obj);
    form.append('function', func);
    axios.post(baseURL+'app_handler.php?obj='+obj+'&func='+func,form,{
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
      callback(response.data)
      if(DEBUG)
        console.log(response.data);
    }).catch((error)   => { console.log(error) });
  },
  getImgPath (img) {
    return baseURL+"reward_img/"+img;
  },
  getImgPathPromo (img) {
    return baseURL+"promocion_img/"+img;
  },
  getDownloadURL(archivo) {
    return baseURL+"descarga_archivo.php?file="+archivo;
  },
  getVideo (video) {
    return baseURL+"descargas/"+video;
  },
}